module.exports = __webpack_public_path__ + "img/8535044.png";